import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';
import { IOMode } from '@appblocks/codegeneration/types';

export default class Tibbit_00_3 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_00_3';
        this.name = 'Tibbit 00_3';
        this.lines = 2;
        this.mode = IOMode.IO;
        this.initLines();
    }
}
